const getMenuByUrl = (
  state: WebOrder.State['flipdish']['MenuData'],
  props: { menuUrl: string },
) => {
  const menu = state[props.menuUrl];
  if (menu && menu.status === 'success') {
    return menu.data;
  }

  return null;
};

export const menuSelectors = {
  getMenuByUrl,
};
